function getDefaultState() {
  return {
    snackBar: {
      ativo: false,
      mensagem: '',
      color: '',
      timeout: 0
    }
  };
}

const state = getDefaultState();

const getters = {};

const mutations = {
  setarAtivo(state, status) {
    state.snackBar.ativo = status;
  },
  setarMensagem(state, mensagem) {
    state.snackBar.mensagem = mensagem;
  },
  setarColor(state, color) {
    state.snackBar.color = color;
  },
  setarTimeout(state, timeout) {
    state.snackBar.timeout = timeout;
  }
};

const actions = {
  habilitarSnackBar: ({commit}, dados) => {
    commit('setarAtivo', dados.ativo);
    commit('setarMensagem', dados.mensagem);
    commit('setarColor', dados.color);
    commit('setarTimeout', dados.timeout);
  }
};

export default { namespaced: true, state, mutations, getters, actions };
  